var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.358 4.83037L47.2732 2.1H42.5H7.5H2.72675L6.64198 4.83037L24.142 17.0344L25 17.6327L25.858 17.0344L43.358 4.83037ZM2.07143 32.4V33.8482C1.70622 33.4595 1.5 32.9416 1.5 32.4V3.6C1.5 3.03921 1.72112 2.50377 2.11092 2.11084C2.50033 1.71832 3.02593 1.5 3.57143 1.5H46.4286C46.9741 1.5 47.4997 1.71832 47.8891 2.11084C48.2789 2.50377 48.5 3.03921 48.5 3.6V32.4C48.5 32.9416 48.2938 33.4595 47.9286 33.8482V32.4V5.238V2.36274L45.5704 4.00775L25.1597 18.2458L25.1583 18.2467C25.1106 18.28 25.0554 18.297 25 18.297C24.9446 18.297 24.8894 18.28 24.8417 18.2467L24.8403 18.2458L4.42962 4.00775L2.07143 2.36274V5.238V32.4ZM3.57143 34.5C3.03097 34.5 2.51005 34.2857 2.12176 33.9H3.57143H46.4286H47.8782C47.49 34.2857 46.969 34.5 46.4286 34.5H3.57143Z",
    fill: "#23395D",
    stroke: "#23395D",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d02faaadb04df6d089fa31135f1a708a.svg";
export { ForwardRef as ReactComponent };